import { FormikProps } from "formik";
import { useEffect } from "react";
interface AutoUpdateAddress<T> {
  formik: FormikProps<T>;
  fieldNames: Array<keyof T>;
  name?: keyof T;
  otherValues?: Array<string>;
}
const useAutoUpdateAddress = <T>({
  formik,
  fieldNames,
  name = "address" as keyof T,
  otherValues = [],
}: AutoUpdateAddress<T>) => {
  useEffect(() => {
    const addressStr = [
      ...fieldNames.map((item) => formik.values[item]),
      ...otherValues,
    ]
      .toString()
      .replaceAll(",", " ")
      .trim();
    formik.setFieldValue(name as string, addressStr);
    if (addressStr) formik.setFieldTouched(name as string, true);
  }, [formik.values, JSON.stringify(otherValues)]);
  return {};
};

export default useAutoUpdateAddress;
